<template>

    <div v-if="show" v-touch:swipe.left="next" v-touch:swipe.right="previously" class="sfs__container">

        <div class="sfs__header">

            <div class="sfs__bloc sfs__bloc-btn-container">

                <div class="sfs__bloc-btn" @click="close">

                    <img class="sfs__btn-img" src="/img/icons/cancel-white.svg">

                </div>

            </div>

            <div class="sfs__bloc sfs__bloc-progress-container">

                <img v-for="(story, index) in stories" :class="{ 'sfs__progress-indicator-active': index === indexStories }" class="sfs__progress-indicator" src="/img/stories/empty.svg"/>

            </div>

            <div class="sfs__bloc sfs__bloc-btn-container sfs__bloc-hide">

                <div class="sfs__bloc-btn" src="/img/icons/download-white.svg"></div>

            </div>

        </div>

        <start v-if="firstScreen" :data="currentStory"></start>

        <envelop v-if="envelopScreen" :data="currentStory"></envelop>

        <graphic v-if="graphicScreen" :data="currentStory"></graphic>

        <industry v-if="industryScreen"></industry>

        <lamp v-if="lampScreen"></lamp>

        <podium v-if="podiumScreen" :data="currentStory" @close="next"></podium>

        <last v-if="lastScreen" @close="close"></last>

    </div>

</template>

<script>

import Envelop from '@/components/stories/templates/Envelop.vue'
import Graphic from '@/components/stories/templates/Graphic.vue'
import Industry from '@/components/stories/templates/Industry.vue'
import Lamp from '@/components/stories/templates/Lamp.vue'
import Last from '@/components/stories/templates/Last.vue'
import Podium from '@/components/stories/templates/Podium.vue'
import Start from '@/components/stories/templates/Start.vue'

import Tag from '@/modules/tag'

export default {

    name: 'stories-full-screen',

    components: {Envelop, Graphic, Industry, Lamp, Last, Podium, Start},

    watch: {

        currentStory: function (newValue) {

            if (newValue) {
                switch (newValue.type) {
                    case 'intro':
                        Tag.pageViewAll(this, 'stories_intro')
                        break
                    case 'carbon-footprint':
                        Tag.pageViewAll(this, 'stories_carbon-footprint')
                        break
                    case 'open-rate':
                        Tag.pageViewAll(this, 'stories_open-rate')
                        break
                    case 'mail-attachment':
                        Tag.pageViewAll(this, 'stories_mail-attachment')
                        break
                    case 'monthly-expenses':
                        Tag.pageViewAll(this, 'stories_monthly-expenses')
                        break
                    case 'top-categories-purchases':
                        Tag.pageViewAll(this, 'stories_top-categories-purchases')
                        break
                    case 'ending':
                        Tag.pageViewAll(this, 'stories_ending')
                        break
                }
            }

            if (newValue) {

                this.startTimer(newValue.type)
            }
        }

    },

    computed: {

        firstScreen() {
            return this.currentStory.type === 'intro'
        },

        lastScreen() {
            return this.currentStory.type === 'ending'
        },

        envelopScreen() {
            return this.currentStory.type === 'open-rate'
        },

        graphicScreen() {
            return this.currentStory.type === 'monthly-expenses'
        },

        industryScreen() {
            return this.currentStory.type === 'carbon-footprint'
        },

        lampScreen() {
            return this.currentStory.type === 'mail-attachment'
        },

        podiumScreen() {
            return this.currentStory.type === 'top-categories-purchases'
        },

        currentStory() {
            return this.stories[this.indexStories]
        }
    },

    created() {

        window.addEventListener('keydown', this.keydown)
    },

    data() {
        return {
            stories: [],
            indexStories: -1,
            show: false,
            step: ''
        }
    },

    methods: {

        open(data) {

            this.stories = data.screens
            this.show = true
            this.next()
        },

        keydown(event) {

            if (event.keyCode === 13 || event.keyCode === 32 || event.keyCode === 39) {

                this.next()

            }
        },

        previously() {

            if (this.indexStories === 0) {

                this.close()

            } else {

                this.indexStories = this.indexStories - 1

            }

        },

        next() {

            const max = this.stories.length

            if (this.indexStories === max - 1) {

                this.close()

            } else {

                this.indexStories = this.indexStories + 1

            }

        },

        close() {
            this.show = false
            this.step = ''
            this.stories = []
            this.indexStories = -1
        },

        startTimer(type) {
            setTimeout(() => {

                if (this.currentStory && this.currentStory.type && this.currentStory.type === type) {

                    this.next()

                }

            }, 6 * 1000)

        }
    },

    destroyed() {

        window.removeEventListener('keydown', this.keydown)
    }

}

</script>

<style lang="scss" scoped>

.sfs {
    &__container {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: darkturquoise;
        z-index: 1;
    }

    &__header {
        height: 74px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1;
        padding: 16px 16px 14px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }

    &__bloc {
        display: flex;
    }

    &__bloc-hide {
        visibility: hidden;
    }

    &__progress-indicator {
        width: 4px;
        object-fit: contain;
        margin: 0 2px;
        opacity: 0.5;
    }

    &__progress-indicator-active {
        opacity: 1;
        width: 6px;
        margin: 0 4px;
    }

    &__bloc-btn-container {
        margin-top: 14px;
        align-items: center;
        justify-content: center;
    }

    &__bloc-progress-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__bloc-btn {
        width: 32px;
        height: 32px;
        border-radius: 100px;
        background-color: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__bloc-progress {

    }

    &__btn-img {
        width: 20px;
        object-fit: contain;
    }
}


</style>
